import React, {Suspense, useEffect, useState} from 'react'
import {renderRoutes} from 'react-router-config'
import PropTypes from 'prop-types'
import {makeStyles} from '@material-ui/styles'
import {Hidden, LinearProgress} from '@material-ui/core'
import NavBar from './NavBar'
import TopBar from './TopBar'
import {usePusher} from "../../PusherContext"
import {useDispatch, useSelector} from "react-redux"
import {getData} from "../../admin-utils/API"
import NotificationActions, {saveNotifications} from "../../redux/reducers/NotificationRedux"

const savedDirection = localStorage.getItem('direction')
document.body.style.direction = savedDirection

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0 // IE11 fix
    }
  },
  content: {
    // paddingTop: 64,
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    },
    // [theme.breakpoints.up('lg')]: {
    //   paddingTop: 56
    // },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 56
    }
  }
}))

function Dashboard({route}) {
  const classes = useStyles()
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false)
  const pusher = usePusher()
  const {user, token} = useSelector((state) => state.session)
  const dispatch = useDispatch()

  useEffect(() => {
    getNotifications()
  }, [])

  useEffect(() => {
    if (pusher) {
      const realtimeChannel = pusher.subscribe(
        `notifications`
      )

      realtimeChannel.bind(`region-${user?.region?.id || 0}`, getNotifications)
    }
  }, [pusher])

  function getNotifications() {
    dispatch(NotificationActions.clear())

    getData('notification', {
      region_id: `${user?.region?.id || 0}`
    }, token).then(data => {
      const notifications = data?.data

      // Save all notifications
      dispatch(NotificationActions.saveNotifications(notifications))

      notifications.map(notification => {
        dispatch(NotificationActions.setNotification(notification.href, 1, 'add'))
      })
    })
  }

  return (
    <>
      {/*<TopBar onOpenNavBarMobile={() => setOpenNavBarMobile(true)}/>*/}

      <Hidden lgUp>
        <TopBar onOpenNavBarMobile={() => setOpenNavBarMobile(true)}/>
      </Hidden>

      <NavBar
        onMobileClose={() => setOpenNavBarMobile(false)}
        openMobile={openNavBarMobile}
      />
      <div className={classes.container}>
        <div className={classes.content}>
          <Suspense fallback={<LinearProgress/>}>
            {renderRoutes(route.routes)}
          </Suspense>
        </div>
      </div>
    </>
  )
}

Dashboard.propTypes = {
  route: PropTypes.object
}

export default Dashboard
